import api from "./api";

export const UsersAPI = {
  list: (schoolId) =>
    api(`/users${schoolId ? `?schoolId=${schoolId}` : ""}`),
  create: (data) =>
    api("/users", { method: "POST", body: JSON.stringify(data) }),
  delete: (id) => api(`/users/${id}`, { method: "DELETE" }),
};